import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useResolvedPath, useNavigate } from "react-router-dom";
import "../pages/homePage.css?v=1.0";

const NavigateListItem = ({ to, icon, text }) => {
  const navigate = useNavigate();
  const resolvedPath = useResolvedPath(to); // Resolve relative paths dynamically

  return (
    <ListItem
      button
      style={{ cursor: "pointer" }}
      className="featured-item"
      onClick={() => navigate(resolvedPath.pathname)}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );
};

export default NavigateListItem;
